<template>
  <div id="nav">
    <div class="logo" :style="{ width: aside }">
      <img src="../assets/logo.svg" style="height: 20px; padding: 10px 0">
    </div>

    <div :style="{ width: 'calc(100% - ' + aside }">
      <Filters
        size="small"
        placeholder="Search by a name or public IP"
        :class="{ hide: !project }"
      />

      <div class="actions">
        <el-dropdown v-if="project" class="create-dropdown" trigger="click" @command="action">
          <el-button type="primary" size="small">
            Create
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>

          <el-dropdown-menu class="create-menu" slot="dropdown">
            <el-dropdown-item command="/create">
              <strong>Create Cloud Server</strong>
            </el-dropdown-item>

            <el-dropdown-item command="/create/wordpress" divided>
              <div class="app wordpress">Deploy Wordpress</div>
            </el-dropdown-item>

            <el-dropdown-item command="/create/laravel">
              <div class="app laravel">Deploy Laravel project</div>
            </el-dropdown-item>

            <el-dropdown-item command="/create/php">
              <div class="app php">Deploy PHP code</div>
            </el-dropdown-item>

            <el-dropdown-item command="/create/node">
              <div class="app node">Deploy Node.js code</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <DevOps class="devops-mode" />

        <el-dropdown class="user-dropdown" trigger="click" @command="action">
          <el-button type="text" size="small">
            <el-avatar size="small">{{ user.firstName[0].toUpperCase() }}</el-avatar>
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>

          <el-dropdown-menu class="user-menu" slot="dropdown">
            <div class="name">
              <span>{{ user.firstName }} {{ user.lastName }}</span><br>
              <small v-if="permission('owner')"><i class="mdi mdi-shield-account" /> Owner</small>
              <small v-else-if="permission('admin')"><i class="mdi mdi-account-group" /> Administrator</small>
              <small v-else-if="permission('manager')"><i class="mdi mdi-account-supervisor" /> Manager</small>
              <small v-else-if="permission('developer')"><i class="mdi mdi-account" /> Developer</small>
              <small v-else-if="permission('accounting')"><i class="mdi mdi-account-outline" /> Accounting</small>
            </div>

            <el-dropdown-item command="/account" divided>
              My Account
            </el-dropdown-item>

            <el-dropdown-item command="/ssh-key">
              Upload SSH key
            </el-dropdown-item>

            <el-dropdown-item command="/projects">
              Manage Projects
            </el-dropdown-item>

            <el-dropdown-item command="/tokens">
              API keys
            </el-dropdown-item>

            <el-dropdown-item command="signout" divided>
              Sign Out
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Filters from './Filters'
import DevOps from './DevOps'

export default {
  props: {
    aside: {
      type: String,
      default: '180px'
    },
    search: {
      type: Boolean,
      default: false
    },
    application: Boolean,
    instance: Boolean
  },
  components: {
    Filters,
    DevOps
  },
  data () {
    return {
      devops: false
    }
  },
  computed: {
    active () {
      if (this.$route.name === 'domains' || this.$route.name === 'application') {
        return '/applications'
      }
      return '/' + (this.$route.path || '').substring(1).split('/').shift()
    },
    ...mapGetters(['permission']),
    ...mapState(['project', 'access', 'user'])
  },
  methods: {
    action (command) {
      if (command[0] === '/') {
        this.$router.push(command)
      } else if (command.match(/^http/)) {
        window.open(command, '_blank')
      } else {
        this[command]()
      }
    },
    update (prop) {
      this.$emit('update:' + prop, true)
    },
    signout () {
      this.$store.commit('logout')
      this.$store.commit('reset')
    }
  }
}
</script>

<style lang="scss">
  @import "../theme";

  #nav {
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;

    > div {
      float: left;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }

    #filters {
      width: 50%;
      float: left;
      position: relative;
      top: 4px;

      &.hide {
        visibility: hidden;
      }
    }

    .actions {
      text-align: right;
    }

    .el-button--primary {
      background-color: transparent;
      border-color: #000;
      color: #000;
    }

    .create-dropdown {
      position: relative;
      top: -10px;
    }

    .user-dropdown {
      .el-avatar {
        background-color: $--color-text-alt;
      }
      .el-button--text {
        color: #000;
        padding: 5px 0;

        .el-icon--right {
          position: relative;
          top: -9px;
        }
      }
    }

    .devops-mode {
      margin-left: 10px;
      margin-right: 10px;
      padding-left: 10px;
      border-left: 1px solid $--border-color-base;
      font-size: 12px;
      display: inline-block;
      line-height: 28px;
      position: relative;
      top: -9px;

      .el-switch {
        margin-top: -2px;
      }
    }
  }

  .user-menu {
    .name {
      padding: 0 20px;
    }
    .el-dropdown-menu__item {
      font-size: 13px;
    }
  }

  .create-menu {
    .app {
      background-position: center left 0px;
      background-repeat: no-repeat;
      background-size: 16px;
      padding-left: 27px;

      &:hover {
        background-color: transparent !important;
      }
    }
  }
</style>
